<template>
    <div class="alt-ean-warning text-warning" v-if="altEanError">
        <a-icon icon="WarningFull"
            width="16px"
            height="16px"
            class="mr-2"
        />

        <div>
            <p class="text-sm text-primary mb-0">
                Podany kod lokalny jest już przypisany do innego
                <v-popover
                    :container="false"
                    style="display: inline-block"
                    class="alt-ean-warning-tooltip"
                >
                    <span
                        class="text-primary text-underline cursor-pointer"
                        style="font-weight: 600;"
                    >
                        produktu
                    </span>
                    <template slot="popover">
                        <div class="d-flex gap-1 py-1 justify-content-between">
                            <div class="c-fig">
                                <img :src="altEanError.image.urls.small" />
                            </div>
                            <div class="text-right">
                                <p class="mb-0 prod-name">
                                    <strong v-text="altEanError.name" />
                                </p>
                                <p class="text-tiny mb-0">
                                    EAN: {{ altEanError.ean }}
                                </p>
                            </div>
                            <div
                                v-close-popover
                                class="alt-ean-warning-close cursor-pointer text-danger"
                            >
                                ×
                            </div>
                        </div>
                    </template>
                </v-popover>
                w tym sklepie.
            </p>
            <p class="text-sm text-primary mb-0">
                Nie zostanie on zapisany w bazie kodów lokalnych.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        altEanError: {
            type: Object,
            default: undefined
        }
    }
}
</script>

<style lang="scss">
.alt-ean-warning {
    display: flex;
    padding: 8px 16px;
    border: 1px solid var(--color-warning);
    border-radius: var(--border-radius);
    background-color: var(--color-white);
    position: relative;

    .a-icon {
        min-width: 16px;
        transform: translateY(3px);
    }
}

.alt-ean-warning-tooltip {
    word-break: break-word;

    .tooltip {
        width: 250px;
        .popover-inner {
            padding: 6px 10px;
        }
    }

    .c-fig {
        --img-size: 40px;
        min-width: var(--img-size);
        img {
            width: var(--img-size);
            height: var(--img-size);
            object-fit: cover;
            border-radius: 4px;
        }
    }
}

.alt-ean-warning-close {
    --close-size: 18px;

    position: absolute;
    top: -6px;
    right: -6px;
    padding: 4px;
    width: var(--close-size);
    height: var(--close-size);
    border: 1px solid var(--color-gray-300);
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--color-white);
    border-radius: 10px;
    font-size: 16px;
}
</style>
